module.exports = __webpack_public_path__ + "img/pEasy.afdf35f8.png";